import { useState } from 'react';
import logoUrl from '../../shared/assets/icon/logo.svg';
import MediaFigure from '../../shared/components/ui/MediaFigure';
import AchievementList from '../../shared/components/ui/AchievementList';
import PromoDetails from '../../shared/components/ui/PromoDetails';
import SocialButtons from '../../shared/components/ui/SocialButtons';

const HomePage = () => {
  const [count] = useState(2271);

  return (
    <main className="flex flex-row items-center gap-24 pt-6 container_default">
      <MediaFigure />
      <section className="wrapper-content">
        <header className="content__logo">
          <img src={logoUrl} alt="Логотип ШИЛО" />
        </header>
        <section className="content__count" aria-label="Счётчик активаций">
          <p className="content__count-span">Cейчас активировано</p>
          <strong className="content__count-number">
            <output className="content__count-quantity">{count}</output>
            <span className="content__count-text">промокодов</span>
          </strong>
        </section>
        <AchievementList count={count} />
        <p className="content__text">
          Используй промокод «SHILO» при регистрации — получи бонус и начни игру
          с преимуществом!
        </p>
        <PromoDetails />
        <SocialButtons />
        <section className="description">
          <p className="description__text">
            После активации промокода ты автоматически участвуешь в розыгрышах
            на каждом <span>рубеже</span>
          </p>
        </section>
      </section>
    </main>
  );
};

export default HomePage;
